export default "__VITE_ASSET__D_rk8VQ4__"